export const gallery_status = [
  {
    id: 1,
    name: 'Activa'
  },
  {
    id: 2,
    name: 'Inactiva'
  }
]


// WEBPACK FOOTER //
// ./src/components/galleries/mocks.js